// extracted by mini-css-extract-plugin
export var banner = "_gk-0";
export var closeButton = "_gk-2";
export var greenCheckmark = "_gk-3";
export var hereLink = "_gk-4";
export var titleIcon = "_gk-1";